import { memo } from 'react';
import styled from 'styled-components';
import { VStack } from '@cbhq/cds-web/layout';
import BrandColumn from './components/columns/BrandColumn.js';
import BusinessesColumn from './components/columns/BusinessesColumn.js';
import CompanyColumn from './components/columns/CompanyColumn.js';
import DevelopersColumn from './components/columns/DevelopersColumn.js';
import IndividualsColumn from './components/columns/IndividualsColumn.js';
import InstitutionsColumn from './components/columns/InstitutionsColumn.js';
import LearnColumn from './components/columns/LearnColumn.js';
import SupportColumn from './components/columns/SupportColumn.js';
import { GlobalFooterProvider } from './context/GlobalFooterContext.js';
import devices from './shared/styles/devices.js';
import { theme } from './shared/styles/theme.js';
import { jsx, jsxs } from 'react/jsx-runtime';
function Footer({
  themeMode,
  userLocaleInfo,
  localeInformation
}) {
  return /*#__PURE__*/jsx(GlobalFooterProvider, {
    userLocaleInfo: userLocaleInfo,
    children: /*#__PURE__*/jsx(Container, {
      id: "footer-site-index",
      children: /*#__PURE__*/jsxs(FooterWrapper, {
        children: [/*#__PURE__*/jsx(BrandColumn, {
          themeMode: themeMode,
          userLocaleInfo: userLocaleInfo,
          localeInformation: localeInformation
        }), /*#__PURE__*/jsxs(PageLinksColumns, {
          children: [/*#__PURE__*/jsxs(VStack, {
            gap: 3,
            spacingBottom: 3,
            children: [/*#__PURE__*/jsx(CompanyColumn, {}), /*#__PURE__*/jsx(LearnColumn, {})]
          }), /*#__PURE__*/jsxs(VStack, {
            gap: 3,
            spacingBottom: 3,
            children: [/*#__PURE__*/jsx(IndividualsColumn, {}), /*#__PURE__*/jsx(BusinessesColumn, {}), /*#__PURE__*/jsx(InstitutionsColumn, {}), /*#__PURE__*/jsx(DevelopersColumn, {})]
          }), /*#__PURE__*/jsx(VStack, {
            gap: 3,
            children: /*#__PURE__*/jsx(SupportColumn, {})
          })]
        })]
      })
    })
  });
}
const Container = styled.div`
  width: 100%;
`;
const FooterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  width: 100%;
  background: ${theme.color.white};
  @media (${devices.phone}) {
    grid-template-columns: 1fr;
  }
  color: ${theme.color.white};
`;
const PageLinksColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  @media (${devices.phone}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (${devices.phone_small}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
const Footer$1 = /*#__PURE__*/memo(Footer);
export { Footer$1 as default };
//# sourceMappingURL=Footer.js.map
